import { Text } from "@ui-kitten/components";
import { EventNoticeDetails } from "features/types";
import React, { useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import EventNoticeIcon from "./EventNoticeIcon";
import Popover from "./Popover/Popover";

interface NoticeTagProps {
  type: EventNoticeDetails["type"];
  tag?: string;
  description?: string;
  shouldShowPopover?: boolean;
  onPress?: () => void;
}

const NoticeTag: React.FC<NoticeTagProps> = ({
  type,
  tag,
  description,
  shouldShowPopover = false,
  onPress,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <Pressable
      onPress={(e) => {
        if (onPress) {
          onPress();
          return;
        }
        e.stopPropagation();
        shouldShowPopover && setVisible((visible) => !visible);
      }}
    >
      <Popover isOpen={visible} popoverText={description || ""}>
        <View style={styles.tagContainer}>
          <View style={{ marginRight: 5 }}>
            <EventNoticeIcon type={type} size={12} />
          </View>
          <Text numberOfLines={1}>{tag}</Text>
        </View>
      </Popover>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  tagContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    alignSelf: "flex-start",
    paddingHorizontal: 8,
    borderRadius: 4,
    flexShrink: 1,
  },
});
export default NoticeTag;
